import React, { useState, useEffect, useRef } from "react";
import { FormControl, InputLabel, MenuItem, TableRow, Table, TableHead, TableBody, TableCell,
  TableContainer,
        Paper,
 } from "@material-ui/core";
import TrainerService from "./Locality/Service/trainerService";
import { Grid, Card, Box, Select } from "@material-ui/core";
import StudentService from "./Locality/Service/studentService";
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import TrainerRegistrationService from "./Locality/Service/trainerRegistrationService";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, IconButton,
} from "@material-ui/core";
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import requests from './Locality/Service/httpService';
// Removed Video.js - using native HTML5 video for better reliability

// Utility function to convert Azure Blob URL to proxy URL for proper Range request support
const convertToProxyUrl = (blobUrl) => {
  if (!blobUrl || typeof blobUrl !== 'string' || blobUrl.trim() === '') {
    return blobUrl;
  }
  
  // Check if it's an Azure Blob Storage URL
  const blobPattern = /https?:\/\/artistimages\.blob\.core\.windows\.net\/montestory\/(.+)/;
  const match = blobUrl.match(blobPattern);
  
  if (match && match[1]) {
    // Extract the filename from the blob URL
    const fileName = match[1].split('?')[0]; // Remove query parameters if any
    
    if (fileName) {
      // Get base URL from httpService
      const baseURL = requests.baseURL();
      // Return proxy URL with properly encoded filename
      return `${baseURL}/video/${encodeURIComponent(fileName)}`;
    }
  }
  
  // Return original URL if not a blob URL
  return blobUrl;
};
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#0f3b62ad",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  tableOverflow: {
    overflowX: 'auto',
  },
  dialogPaper: {
    maxWidth: '900px',
    width: '95%',
    margin: '20px auto',
    borderRadius: '12px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '95%',
      width: '95%',
      margin: '10px auto',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      width: '100%',
      margin: '0',
      borderRadius: '0',
      height: '100%',
      maxHeight: '100vh',
    },
  },
  mediaPlayer: {
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '8px',
    backgroundColor: '#000',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  videoPlayer: {
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    minHeight: '400px',
    maxHeight: '70vh',
    borderRadius: '8px',
    backgroundColor: '#000',
    objectFit: 'contain',
    [theme.breakpoints.down('md')]: {
      minHeight: '350px',
      maxHeight: '60vh',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '250px',
      maxHeight: '50vh',
      width: '100%',
    },
  },
  navigationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  mediaContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px',
    padding: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  emptyMessage: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  emptyIcon: {
    fontSize: 64,
    color: theme.palette.text.disabled,
    marginBottom: theme.spacing(2),
  },
  mediaCounter: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  navButton: {
    backgroundColor: '#5c7a94',
    color: 'white',
    '&:hover': {
      backgroundColor: '#4a6278',
    },
    '&:disabled': {
      backgroundColor: '#e0e0e0',
      color: '#9e9e9e',
    },
  },
}));

export default function TrainingSession() {
  const tableHeaders = ['Class', 'Student Name', 'Area of Work', 'List of Activities', 'Exercise', 'Remarks', 'Date', 'Key'];
  const classes = useStyles();
  const [activityList, setActivityList] = useState([]);
  const [addClassList, setAddClassList] = useState([]);
  const [trainerList, setTrainerList] = useState([]);
  const [classId, setClassId] = useState("");
  const [trainerRegistrationList, setTrainerRegistrationList] = useState([]);
  const [keyValue, setKeyValue] = useState("");
  const [trainerRegistration, setTrainerRegistration] = useState([])
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(5);
  const [mediaUrls, setMediaUrls] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [mediaType, setMediaType] = useState(""); // "audio" or "video"
  const [openPlayer, setOpenPlayer] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {

    getTrainerList();
    getTrainerRegistrationList();

    return () => {

      setTrainerList([]);
      setTrainerRegistrationList([]);

    }
  }, []);

  // Handle video playback when dialog opens or video changes
  useEffect(() => {
    if (mediaType === 'video' && mediaUrls.length > 0 && openPlayer && videoRef.current && mediaUrls[currentIndex]) {
      const video = videoRef.current;
      
      // Set video source
      video.src = mediaUrls[currentIndex];
      video.load();
      
      // Try to play the video
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log('Autoplay was prevented:', error);
          // Video will play when user clicks play button
        });
      }
    }
  }, [mediaUrls, currentIndex, mediaType, openPlayer]);
  const handlePlay = (urls, type) => {
    // Handle both array and string formats
    let urlArray = [];
    if (Array.isArray(urls)) {
      urlArray = urls.filter(url => url && url.trim() !== '');
    } else if (urls && typeof urls === 'string') {
      urlArray = [urls];
    }

    // Check if array is empty
    if (urlArray.length === 0) {
      setMediaUrls([]);
      setMediaType(type);
      setOpenPlayer(true);
      return;
    }

    // Convert blob URLs to proxy URLs for proper Range request support (video seeking)
    const convertedUrls = urlArray.map(url => {
      if (type === 'video') {
        return convertToProxyUrl(url);
      }
      return url; // Audio can use direct URLs
    });

    setMediaUrls(convertedUrls);
    setCurrentIndex(0);
    setMediaType(type);
    setOpenPlayer(true);
  };

  const handleClosePlayer = () => {
    // Pause and reset video
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.src = '';
      videoRef.current.load();
    }
    setOpenPlayer(false);
    setMediaUrls([]);
    setCurrentIndex(0);
    setMediaType("");
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < mediaUrls.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };
  const getTrainerRegistrationList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    TrainerRegistrationService.getAllTrainerRegistration().then((res) => {
      const mapResult = res.map((trainerRegistration) => {
        return { ...trainerRegistration }
      })
      setTrainerRegistrationList(mapResult);

    }).catch((err) => {
      // setError(err.message);
    });
  }
  const handleChangePage = (event, newpage) => {
    setpg(newpage);
  }

  const handleChangeRowsPerPage = (event) => {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }
  const dateAndTime = (date) => {

    const systemDate = new Date(date);
    const formattedDateTime = systemDate.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true,

    });
    return formattedDateTime;
  }
  const getTrainerList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));

    TrainerService.getAllTrainer().then((res) => {
      // Merge trainer and trainer registration data by mobile number
      const merged = res.map((trainer) => {
        const matchingRegistration = trainerRegistrationList.find(
          (reg) => reg.mobileNumber === trainer.mobileNumber
        );

        return {
          ...trainer,
          profile: matchingRegistration ? matchingRegistration.profile : null,
        };
      });

      setTrainerList(merged);
    }).catch((err) => {
      console.error(err);
    });
  };


  // Filter activityList to only include entries with records
  const filteredActivityList = activityList.filter(activitydetails =>
    activitydetails.activityRecordsId && activitydetails.activityRecordsId.length > 0
  );

  return (
    <>

      <PageTitle title="Training Session" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                            <TableContainer component={Paper} style={{ maxHeight: 500 }}>
            
            <Table stickyHeader className="mb-0">
              <TableHead >
                <TableRow>

                  <StyledTableCell >Profile</StyledTableCell>
                  <StyledTableCell >Name</StyledTableCell>
                  <StyledTableCell >Class</StyledTableCell>
                  <StyledTableCell >Subject</StyledTableCell>
                  <StyledTableCell >Date</StyledTableCell>
                  <StyledTableCell >Video</StyledTableCell>
                  <StyledTableCell >Audio</StyledTableCell>
                  {/* <StyledTableCell >Staus</StyledTableCell> */}

                  {/* {addUserPermitionsList && addUserPermitionsList.studentDetailsDelete ?
                                        <StyledTableCell >Delete</StyledTableCell>: null } */}
                </TableRow>
              </TableHead>
              <TableBody>
                {trainerList.map((trainer) => (
                  <TableRow key={trainer._id}>
                    <TableCell className="pl-3 fw-normal">
                      {trainer.trainerRegisterId && trainer.trainerRegisterId.profile ? (
                        <img
                          src={trainer.trainerRegisterId.profile}
                          alt="trainer"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '';
                          }}
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                        />
                      ) : (
                        <AccountCircleIcon style={{ fontSize: 40, color: '#999' }} />
                      )}
                    </TableCell>

                    <TableCell className="pl-3 fw-normal">
                      {trainer.trainerRegisterId?.name || 'N/A'}
                    </TableCell>                    <TableCell className="pl-3 fw-normal" >{trainer.classId ? trainer.classId.className : ''}</TableCell>
                    <TableCell className="pl-3 fw-normal" >{trainer.subject}</TableCell>
                    <TableCell className="pl-3 fw-normal">{dateAndTime(trainer.createdAt)}</TableCell>

                    {/* <TableCell className="pl-3 fw-normal">
                      <Button
                        variant="contained"
                        size="small"
                        style={{ marginLeft: '10px', minWidth: '60px', backgroundColor: '#5c7a94', color: 'white' }}
                      // onClick={() => window.open(`tel:${trainer.mobileNumber}`)}
                      >
                        Video
                      </Button>
                    </TableCell>

                    <TableCell className="pl-3 fw-normal">
                      <Button
                        variant="contained"
                        size="small"
                        style={{ marginLeft: '10px', minWidth: '60px', backgroundColor: '#5c7a94', color: 'white' }}
                      // onClick={() => window.open(`tel:${trainer.mobileNumber}`)}
                      >
                        Audio
                      </Button>
                    </TableCell> */}
                   <TableCell className="pl-3 fw-normal">
  {trainer.videoURL && Array.isArray(trainer.videoURL) && trainer.videoURL.length > 0 ? (
    <Button
      variant="contained"
      size="small"
      style={{ marginLeft: '10px', minWidth: '60px', backgroundColor: '#5c7a94', color: 'white' }}
      onClick={() => handlePlay(trainer.videoURL, 'video')}
    >
      Video
    </Button>
  ) : trainer.videoURL && typeof trainer.videoURL === 'string' && trainer.videoURL.trim() !== '' ? (
    <Button
      variant="contained"
      size="small"
      style={{ marginLeft: '10px', minWidth: '60px', backgroundColor: '#5c7a94', color: 'white' }}
      onClick={() => handlePlay(trainer.videoURL, 'video')}
    >
      Video
    </Button>
  ) : (
    <span style={{ color: '#999' }}>N/A</span>
  )}
</TableCell>

<TableCell className="pl-3 fw-normal">
  {trainer.audioURL && Array.isArray(trainer.audioURL) && trainer.audioURL.length > 0 ? (
    <Button
      variant="contained"
      size="small"
      style={{ 
        marginLeft: '10px', 
        minWidth: '60px', 
        backgroundColor: '#5c7a94',
        color: 'white'
      }}
      onClick={() => handlePlay(trainer.audioURL, 'audio')}
    >
      Audio
    </Button>
  ) : trainer.audioURL && typeof trainer.audioURL === 'string' && trainer.audioURL.trim() !== '' ? (
    <Button
      variant="contained"
      size="small"
      style={{ 
        marginLeft: '10px', 
        minWidth: '60px', 
        backgroundColor: '#5c7a94',
        color: 'white'
      }}
      onClick={() => handlePlay(trainer.audioURL, 'audio')}
    >
      Audio
    </Button>
  ) : (
    <Button
      variant="contained"
      size="small"
      style={{ 
        marginLeft: '10px', 
        minWidth: '60px', 
        backgroundColor: '#ccc',
        color: 'white'
      }}
      disabled
    >
      Audio
    </Button>
  )}
</TableCell>





                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </TableContainer >
            <TablePagination
              component="div"
              rowsPerPageOptions={[5, 50, 500, 10000]}
              count={trainerList.length}
              page={pg}
              onPageChange={handleChangePage}
              rowsPerPage={rpg}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Widget>
        </Grid>
      </Grid>
      <Dialog 
        open={openPlayer} 
        onClose={handleClosePlayer} 
        maxWidth="lg" 
        fullWidth={true}
        PaperProps={{
          className: classes.dialogPaper,
          style: {
            overflow: 'hidden'
          }
        }}
        scroll="paper"
      >
        <DialogTitle style={{ 
          padding: '20px 24px', 
          fontSize: '20px', 
          fontWeight: '600',
          display: 'flex', 
          alignItems: 'center', 
          gap: '10px',
          borderBottom: '1px solid #e0e0e0',
          backgroundColor: '#fafafa',
        }}>
          {mediaType === 'audio' ? <MusicNoteIcon style={{ color: '#5c7a94' }} /> : <VideoLibraryIcon style={{ color: '#5c7a94' }} />}
          {mediaType === 'audio' ? 'Audio Player' : 'Video Player'}
        </DialogTitle>
        <DialogContent style={{ 
          padding: '24px',
          overflow: 'hidden',
          backgroundColor: '#000',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          {mediaUrls.length === 0 ? (
            <div className={classes.emptyMessage}>
              {mediaType === 'audio' ? (
                <MusicNoteIcon className={classes.emptyIcon} />
              ) : (
                <VideoLibraryIcon className={classes.emptyIcon} />
              )}
              <Typography variant="h6" style={{ marginBottom: '8px', color: '#666' }}>
                No Session Available
              </Typography>
              <Typography variant="body2" style={{ color: '#999' }}>
                {mediaType === 'audio' 
                  ? 'No audio files are available for this training session.' 
                  : 'No video files are available for this training session.'}
              </Typography>
            </div>
          ) : (
            <div className={classes.mediaContainer}>
              {mediaType === 'audio' ? (
                <audio 
                  key={mediaUrls[currentIndex]}
                  controls 
                  className={classes.mediaPlayer}
                  autoPlay
                >
                  <source src={mediaUrls[currentIndex]} type="audio/mpeg" />
                  <source src={mediaUrls[currentIndex]} type="audio/mp3" />
                  <source src={mediaUrls[currentIndex]} type="audio/wav" />
                  Your browser does not support the audio tag.
                </audio>
              ) : (
                <video 
                  ref={videoRef}
                  key={mediaUrls[currentIndex]}
                  controls 
                  className={classes.videoPlayer}
                  autoPlay
                  preload="auto"
                  playsInline
                  controlsList="nodownload"
                  onLoadedMetadata={(e) => {
                    console.log('Video metadata loaded, duration:', e.target.duration);
                  }}
                  onCanPlay={(e) => {
                    console.log('Video can play');
                  }}
                  onSeeking={(e) => {
                    console.log('Seeking to:', e.target.currentTime);
                  }}
                  onSeeked={(e) => {
                    console.log('Seeked to:', e.target.currentTime);
                  }}
                  onError={(e) => {
                    const error = e.target.error;
                    if (error) {
                      console.error('Video error:', {
                        code: error.code,
                        message: error.message
                      });
                    }
                  }}
                >
                  <source src={mediaUrls[currentIndex]} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              
            </div>
          )}
        </DialogContent>
        <DialogActions style={{ 
          padding: '16px 24px', 
          borderTop: '1px solid #e0e0e0',
          backgroundColor: '#fafafa',
          justifyContent: 'space-between',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '12px',
        }}>
          {mediaUrls.length > 1 && (
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px',
              flex: '1',
              justifyContent: 'center',
            }}>
              <IconButton
                className={classes.navButton}
                onClick={handlePrevious}
                disabled={currentIndex === 0}
                aria-label="Previous"
                size="small"
              >
                <SkipPreviousIcon />
              </IconButton>
              
              <Typography variant="body2" style={{ 
                color: '#666',
                fontWeight: '500',
                minWidth: '60px',
                textAlign: 'center'
              }}>
                {currentIndex + 1} / {mediaUrls.length}
              </Typography>
              
              <IconButton
                className={classes.navButton}
                onClick={handleNext}
                disabled={currentIndex === mediaUrls.length - 1}
                aria-label="Next"
                size="small"
              >
                <SkipNextIcon />
              </IconButton>
            </div>
          )}
          <Button 
            onClick={handleClosePlayer} 
            variant="contained"
            style={{
              backgroundColor: '#5c7a94',
              color: 'white',
              padding: '8px 24px',
              fontWeight: '500',
              minWidth: '100px',
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>



    </>
  );
}
const thStyle = {
  padding: "12px",
  fontWeight: "bold",
  color: "#555",
  fontSize: "15px"
};

const tdStyle = {
  padding: "12px",
  fontSize: "14px",
  color: "#444"
};